export default "__VITE_ASSET__44147163__"